import { Images } from '../../../assets'
import { Bubbles } from './components/Bubbles'
import { Tooltip } from './components/Tooltip'
import {
  _getVesselSize,
  _getVesselImage,
  _getAdditionalImage,
  _getVesselContainerHeight
} from './dashboard-jetty.helper'
import useHooks from './dashboard-jetty.hooks'
import {
  Cell,
  Jetty,
  Column,
  Vessel,
  Sidebar,
  JettyName,
  JettyMaps,
  WarningIcon,
  LeftBargeImage,
  LeftCraneImage,
  RightBargeImage,
  RightCraneImage
} from './dashboard-jetty.styled'
import RightTable from './components/RightTable'
import WarningModal from './components/WarningModal'
import { TooltipEquipment } from './components/TooltipEquipment'

const JettySection = ({
  id,
  index,
  Images,
  vessel,
  _getVesselSize,
  _getVesselImage,
  onClickEquipment,
  _getAdditionalImage,
  _getVesselContainerHeight
}) => {
  const rightCrane = vessel?.Crane_Maps?.find(
    (i) => i.Position?.toLowerCase() === 'right'
  )
  const leftCrane = vessel?.Crane_Maps?.find(
    (i) => i.Position?.toLowerCase() === 'left'
  )
  const rightBarge = vessel?.Barge_Maps?.find(
    (i) => i.Position?.toLowerCase() === 'right'
  )
  const leftBarge = vessel?.Barge_Maps?.find(
    (i) => i.Position?.toLowerCase() === 'left'
  )
  return (
    <Jetty id={id} height={_getVesselContainerHeight(vessel?.Vessel_Size)}>
      <LeftCraneImage
        data-tip
        show={!!leftCrane}
        onDoubleClick={() => onClickEquipment(index, 'crane')}
        data-for={`jetty${index + 1}-crane2`}
        src={Images[`${_getAdditionalImage(vessel?.Vessel_Size, 'Crane')}`]}
        alt='Left Crane'
      />
      <LeftBargeImage
        data-tip
        show={!!leftBarge}
        hasCrane={!!leftCrane}
        onDoubleClick={() => onClickEquipment(index, 'barge')}
        data-for={`jetty${index + 1}-barge2`}
        size={_getVesselSize(vessel?.Vessel_Size)}
        src={Images[`${_getAdditionalImage(vessel?.Vessel_Size, 'Barge')}`]}
        alt='Left Barge'
      />
      <Vessel
        data-tip
        data-for={`jetty${index + 1}`}
        src={Images[`${_getVesselImage(vessel?.Vessel_Size)}`]}
      />
      <RightBargeImage
        data-tip
        show={!!rightBarge}
        hasCrane={!!rightCrane}
        onDoubleClick={() => onClickEquipment(index, 'barge')}
        data-for={`jetty${index + 1}-barge1`}
        size={_getVesselSize(vessel?.Vessel_Size)}
        src={Images[`${_getAdditionalImage(vessel?.Vessel_Size, 'Barge')}`]}
        alt='Right Barge'
      />
      <RightCraneImage
        data-tip
        show={!!rightCrane}
        onDoubleClick={() => onClickEquipment(index, 'crane')}
        data-for={`jetty${index + 1}-crane1`}
        src={Images[`${_getAdditionalImage(vessel?.Vessel_Size, 'Crane')}`]}
        alt='Right Crane'
      />
      <TooltipEquipment data={rightCrane} id={`jetty${index + 1}-crane1`} />
      <TooltipEquipment data={leftCrane} id={`jetty${index + 1}-crane2`} />
      <TooltipEquipment data={rightBarge} id={`jetty${index + 1}-barge1`} />
      <TooltipEquipment data={leftBarge} id={`jetty${index + 1}-barge2`} />
      {vessel?.Vessel_Size && (
        <Bubbles data={vessel} vesselSize={vessel?.Vessel_Size} />
      )}
      <Tooltip data={vessel} id={`jetty${index + 1}`} />
    </Jetty>
  )
}

const DashboardJettyAdangBayContainer = (props) => {
  const { data, methods } = useHooks(props)
  const JETTY_NAMES = ['H1', 'H2', 'H3', 'P1', 'P2', 'P3']
  return (
    <>
      {data.isShowWarningInfo && (
        <WarningModal
          isOpen={data.isShowWarningInfo}
          toggleModal={methods.toggleWarningInfo}
        />
      )}
      <JettyMaps>
        <Sidebar>
          <img alt='North Bouy' src={Images.NorthBouy} />
          <img alt='Vessel Bouy' src={Images.VesselBouy} />
          <img alt='South Bouy' src={Images.SouthBouy} />
        </Sidebar>
        <Column>
          {[0, 1, 2].map((rowIdx) => (
            // Kolom 1 (H1, H2, H3)
            <Cell
              borderRight
              key={`col1-row${rowIdx}`}
              borderBottom={rowIdx < 2}
            >
              {(data.availableJetty?.[rowIdx]?.detail?.Crane_Maps?.length > 2 ||
                data.availableJetty?.[rowIdx]?.detail?.Barge_Maps?.length >
                  2) && (
                <WarningIcon
                  onClick={methods.toggleWarningInfo}
                  src={Images.MapsJettyWarning}
                  alt='Warning'
                />
              )}
              <JettyName>{JETTY_NAMES[rowIdx]}</JettyName>
              <JettySection
                id={`dashboard-maps-div-jetty-${rowIdx + 1}`}
                key={rowIdx}
                index={rowIdx}
                Images={Images}
                methods={methods}
                vessel={data.availableJetty?.[rowIdx]?.detail}
                _getVesselSize={_getVesselSize}
                _getVesselImage={_getVesselImage}
                _getAdditionalImage={_getAdditionalImage}
                onClickEquipment={methods.handleUpdateEquipment}
                _getVesselContainerHeight={_getVesselContainerHeight}
              />
            </Cell>
          ))}
        </Column>
        <Column>
          {[3, 4, 5].map((rowIdx) => (
            // Kolom 2 (P1, P2, P3)
            <Cell key={`col2-row${rowIdx}`} borderBottom={rowIdx < 5}>
              {(data.availableJetty?.[rowIdx]?.detail?.Crane_Maps?.length > 2 ||
                data.availableJetty?.[rowIdx]?.detail?.Barge_Maps?.length >
                  2) && (
                <WarningIcon
                  onClick={methods.toggleWarningInfo}
                  src={Images.MapsJettyWarning}
                  alt='Warning'
                />
              )}
              <JettyName>{JETTY_NAMES[rowIdx]}</JettyName>
              <JettySection
                id={`dashboard-maps-div-jetty-${rowIdx + 1}`}
                key={rowIdx}
                index={rowIdx}
                Images={Images}
                methods={methods}
                vessel={data.availableJetty?.[rowIdx]?.detail}
                _getVesselSize={_getVesselSize}
                _getVesselImage={_getVesselImage}
                _getAdditionalImage={_getAdditionalImage}
                onClickEquipment={methods.handleUpdateEquipment}
                _getVesselContainerHeight={_getVesselContainerHeight}
              />
            </Cell>
          ))}
        </Column>
      </JettyMaps>
      <RightTable data={data.availableJetty} metadata={props.metadata} />
    </>
  )
}

export default DashboardJettyAdangBayContainer
